import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { IDGSEnvironment } from '../models/environment';

import { ApiService } from '../services/api.service';
import { StorageService } from '../services/storage.service';
import { FactoryService } from '../services/factory.service';
import { DGSNotificationService } from '../services/notification.service';
import { DGSLowerTranslatePipe } from '../pipes/translate.pipe';
import { AppConfigService } from '../services/settings.service';


export function init_app(appConfig: AppConfigService) {
  const config = () => appConfig.load();
  return config;
}
@NgModule({
  declarations: [
    DGSLowerTranslatePipe,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  exports: [
    DGSLowerTranslatePipe,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DGSCoreModule {
  public static forRoot(environment: IDGSEnvironment, authenticator?: Function): ModuleWithProviders<DGSCoreModule> {
    return {
      ngModule: DGSCoreModule,
      providers: [
        AppConfigService,
        { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppConfigService], multi: true },
        ApiService,
        StorageService,
        FactoryService,
        DGSNotificationService,
        { provide: 'environment', useValue: environment },
        { provide: 'authenticator', useValue: authenticator },
      ],
    };
  }
}
